import React from 'react'
import './MenuItem.css'

type MenuItemProps = {
  active?: boolean
  title: string
  href: string
}


function scrollToTargetAdjusted(target: any){
  var element: any = document.querySelectorAll(`${target}`)[0];
  var headerOffset = 90;
  window.scrollTo(0, element.offsetTop - headerOffset);
}

const MenuItem: React.FC<MenuItemProps> = ({ title, href, active = false }) => {

  

  return (
    <li className='MenuItem flex items-end'>
      {/* <a className={`MenuItem_link mx-6 text-lg ${active ? 'MenuItem_link-active' : ''}`} onClick='scrollToTargetAdjusted()' href={href}>
        {title}
      </a> */}

      <a className={`MenuItem_link mx-6 text-lg`} onClick={()=>{scrollToTargetAdjusted(href)}} >
        {title}
      </a>
    </li>
  )
}


export default MenuItem